import React, { ReactNode } from 'react';
import { Button, IButtonProps } from "components/Button/Button";
import cn from 'classnames';
import './SplitButton.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'react-bootstrap';

export interface ISplitButtonProps extends IButtonProps{
    title?: ReactNode,
}

export function SplitButton({
    children,
    className,
    disabled,
    size,
    theme,
    title,
    ...splitButtonProps
}: ISplitButtonProps) {
    // Custom wrapper for the button so we can pass it as the dropdown toggle.
    // https://react-bootstrap.github.io/components/dropdowns/#custom-dropdown-components
    const ToggleWrap = React.forwardRef(({
        className: toggleClassName,
        onClick: toggleOnClick, 
        ...toggleProps
    }: IButtonProps, ref: React.MutableRefObject<HTMLDivElement>) => {
        // NOTE: react-bootstrap appears to need the ref at the top-level element
        // so that popper positions correctly.
        return <div className={cn('btnGroup', className)} ref={ref}>
            <Button
                className="splitButton_mainButton"
                disabled={disabled}
                size={size}
                theme={theme}
                type="button"
                {...splitButtonProps}
            >
                {title}
            </Button>
            <Button
                className={cn('splitButton_menuButton', toggleClassName)}
                // Apply disabled styling, but don't actually disable this button.
                fakeDisabled={disabled}
                size={size}
                theme={theme}
                onClick={(e) => {
                    e.preventDefault();
                    toggleOnClick(e);
                }}
                {...toggleProps}
            />
        </div>
    })

    return <Dropdown className={cn('splitButton', className)}>
        <Dropdown.Toggle as={ToggleWrap}>
            <FontAwesomeIcon icon="chevron-down" />
        </Dropdown.Toggle>
        <Dropdown.Menu
            popperConfig={{
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            // Offset the menu slightly from the button
                            offset: [0, 2],
                        },
                    },
                ],
            }}
        >
            {children}
        </Dropdown.Menu>
    </Dropdown>
}